import { createContext, useState } from 'react'
import type { ModuleId } from '../types/module'
import type { SubscriptionContextValue } from '../types/subscription'

export const SubscriptionContext = createContext<SubscriptionContextValue>({
  subscribedModules: new Set(),
  isLoading: true,
  isSubscribed: () => false,
})

type Props = { children: React.ReactNode }

export function SubscriptionProvider({ children }: Props) {
  // All modules enabled during development. Replace with real API call before launch.
  const [subscribedModules] = useState<ReadonlySet<ModuleId>>(
    new Set<ModuleId>(['dt-os', 'dt-st', 'dt-cf', 'dt-sc', 'dt-cs', 'dt-fo', 'dt-mo', 'dt-fc', 'dt-dt']),
  )
  const [isLoading] = useState(false)

  const value: SubscriptionContextValue = {
    subscribedModules,
    isLoading,
    isSubscribed: (id) => subscribedModules.has(id),
  }

  return (
    <SubscriptionContext.Provider value={value}>
      {children}
    </SubscriptionContext.Provider>
  )
}
